var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FD0707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1",
    transform: "translate(38.000000, 38.000000)",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.4938,
    y1: 0.4938,
    x2: 41.506,
    y2: 41.506,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.2132,
    y1: 1.201,
    x2: 1.201,
    y2: 42.2132,
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse-1",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 59,
    cy: 59,
    r: 58.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.7204b4601e7329c13608f34de041d8cc.svg";
export { ForwardRef as ReactComponent };